<script>
  export let alt;
  export let desc;
  export let src;
  export let width;
  export let height;
</script>

<div class="image">
  {#if src}
    <div class="image__image">
      <img {src} {alt} {height} {width} loading="lazy" />
    </div>
  {/if}
  {#if desc}
    <p class="image__desc text-small">{desc}</p>
  {/if}
</div>

<style lang="scss">
  .image {
    // border-top: solid 1px $light-border;

    &__image {
      aspect-ratio: 130/68;
      border-radius: 2rem;
      overflow: hidden;
      position: relative;

      @include resp-max('s') {
        border-radius: 2rem 0;
      }

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url(img/noise.png) 300px 300px;
      }
    }

    &__desc {
      max-width: 70rem;
      margin: 3rem auto 0;
      text-align: center;

      @include resp-max('s') {
        color: var(--royal-light);
        margin: 2rem auto 0;
      }
    }
  }
</style>
